import {ActionHandler} from "../../infrastructure/handlers/action-handler";
import {ACTION_TYPES} from "../consts";
import {ComponentController} from "../../infrastructure/controllers/component-controller";

export class PopulateStandingsPreviewHandler extends ActionHandler {
  controller: ComponentController;
  type = ACTION_TYPES.onPopulateStandingsPreview;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    this.state.appState.standingsPreviewDisplayModel.competitionsIds = params.competitionsIds?.removeNulls();
    this.state.appState.standingsPreviewDisplayModel.competitorId = params.competitorId;

    return params;
  }
}
